<template>
  <div>
    <header class="messageHeader">
      <!--<a href="index.html" class="backlastpage"></a>-->
      <p class="headerSpan">09:20</p>
      <div class="writerTop">
        <div>
          取消
        </div>
        <div class="writerC">
          <span to="/message">选择分享权限</span>
        </div>
      </div>
    </header>
    <div class="openMain" >
      <van-radio-group v-model="radio" color="#6e9bcf" >
        <p>
          <van-radio color="#6e9bcf" name="1"><span style="color: #6e9bcf;">所有人可见</span> </van-radio>
        </p>
         <p>
           <van-radio name="2"><span style="color: #6e9bcf;">关注你的人可见</span> </van-radio>
         </p>
        <p>
          <van-radio name="3" ><span style="color: #6e9bcf;">仅自己可见 </span></van-radio>
        </p>
      </van-radio-group>
    </div>


    <footer class="footerlist divflex">
      <a class="footera divflex">
        <img src="../assets/img/footersy.png" alt="">
        <!--<router-link :to="{name:'homePage'}"><span>首页</span></router-link>-->
        <router-link to="/"><span>首页</span></router-link>

      </a>
      <a class="footera divflex">
        <img src="../assets/img/footertj.png" alt="">
        <!--<span>职位</span>-->
        <router-link to="/position"><span>职位</span></router-link>
      </a>
      <a class="footera divflex">
        <img src="../assets/img/footersb.png" alt="">
        <!--<span>消息</span>-->
        <router-link to="/message"><span>消息</span></router-link>
      </a>
      <!--<a href="service.html" class="footera divflex">-->
      <!--<img src="../assets/img/footersb.png" alt="">-->
      <!--<span>公司</span>-->
      <!--</a>-->
      <a class="footera divflex">
        <img src="../assets/img/footerwd.png" alt="">
        <!--<span>我的</span>-->
        <!--<router-link :to="{name:'homePage'}"><span>我的</span></router-link>-->
        <router-link to="/"><span>我的</span></router-link>
      </a>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
        radio:''
      }
    },
    methods:{
      clickIcon(event){
        console.log(event)
        this.bool=!this.bool
        console.log(this.bool)
//        if(bool){
//          this.color="FFFFFF"
//        }
//        this.color="#FFFFFF"
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  @import '../assets/css/common.css';
  @import '../assets/css/header.css';
  @import '../assets/css/footer.css';
  /*@import '../assets/css/mui.min.css';*/
  /*<link rel="stylesheet" href="css/mui.min.css">*/
  .headerSpan{
    padding-left: 2rem;
    line-height: 10px;
    color: #FFFFFF;
  }
  .messageHeader{
    width: 100%;
    background-color: #6e9bcf;
    position: fixed;
    top:0;
  }
  .writerTop{
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #FFFFFF;
    padding: 0 2rem;
  }
  .writerC{
    /*display: flex;*/
    margin: auto;
  }
  .writerC span {
    display: block;
  }
.openMain{
  margin-top: 85px;
}
  .openMain p{
    border-bottom: solid 1px #DEDEDE;
    padding-left: 2rem;
  }
  .van-radio__label{
    color: #6e9bcf;
  }
</style>



// WEBPACK FOOTER //
// src/components/open.vue